import React, { useState } from "react";

import Paper from "../../../Components/UI/Paper";

//MUI
import { Tab, Tabs } from "@mui/material";
import { Box } from "@mui/material";
import MyPageInvoices from "./MyPageInvoices";
import MyPageEndcustomer from "./MyPageEndcustomer";
import MyPageReports from "./MyPageReports";
import { EndCustomerContextProvider } from "Context/EndCustomers";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      style={{
        display: value === index ? "block" : "none",
        minHeight: "400px",
      }}
      id={`x-tabpanel-${index}`}
      aria-labelledby={`x-tab-${index}`}
      {...other}
    >
      {<Box>{children}</Box>}
    </div>
  );
}
function MyPageWorkflow({ endcustomers, client }) {
  const [tabIndex, setTabindex] = useState(0);
  const handleTabSwitch = (event, newValue) => {
    setTabindex(newValue);
  };

  return (
    <>
      <Box component="main" sx={{ flexGrow: 1, pt: "8px" }}>
        <Paper elevation={0}>
          <Tabs
            value={tabIndex}
            onChange={handleTabSwitch}
            sx={{ marginBottom: "2rem" }}
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label="Fakturor" />
            <Tab label="Slutkunder" />
            <Tab label="Rapporter" />
          </Tabs>

          <TabPanel value={tabIndex} index={0} id="tabPanel0">
            <MyPageInvoices endcustomers={endcustomers} client={client} />
          </TabPanel>
          <TabPanel value={tabIndex} index={1} id="tabPanel1">
            <EndCustomerContextProvider>
              <MyPageEndcustomer client={client} />
            </EndCustomerContextProvider>
          </TabPanel>
          <TabPanel value={tabIndex} index={2} id="tabPanel2">
            <MyPageReports />
          </TabPanel>
        </Paper>
      </Box>
    </>
  );
}

export default MyPageWorkflow;
